// extracted by mini-css-extract-plugin
module.exports = {"root":"RevenueImpact_root__C89Dt","deals":"RevenueImpact_deals__2ByIT"};